var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('div',{style:(_vm.isMobile ? 'height: 55vh;' : 'height: 70vh;'),attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }